// VisuallyHidden — text that's announced to screen readers but invisible
// on screen. Use sparingly; prefer real visible labels when possible.
//
// Common uses:
//   <button><Icon /> <VisuallyHidden>Close</VisuallyHidden></button>
//   <span>Loading</span><VisuallyHidden> — please wait</VisuallyHidden>

import type { ReactNode } from "react";

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span style={hiddenStyle}>{children}</span>;
}

const hiddenStyle: React.CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};
